import { FC } from 'react'
import Page from '@/client/submodules/Page'
import { Featured } from './Featured'
import { SampleSearchProps } from './types'

export const SampleSearch: FC<SampleSearchProps> = ({
  seo,
  header,
  footer,
  content: { breadcrumb, header_section, result_section }
}) => (
  <Page seo={seo} header={header} footer={footer}>
    <Featured breadcrumb={breadcrumb} header_section={header_section} result_section={result_section} />
  </Page>
)
